import "./Profile.scss";
import React, { useState, useEffect } from "react";
import apiUser from "../../apis/api.user";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { QRCodeCanvas } from "qrcode.react";
import apiOrder from "../../apis/api.order";
import OrderDetail from "../../components/OrderDetail";
import HeaderNav from "../../components/HeaderNav";
import FooterContent from "../../components/FooterContent";

function Profile() {
  const storedUser = localStorage.getItem("user");
  const [user, setUser] = useState(JSON.parse(storedUser))
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [isChangeName, setIsChangeName] = useState(false);
  const [isChangePhone, setIsChangePhone] = useState(false);
  const [orders, setOrders] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const res = await apiUser.getProfile();
      if (res) {
        setName(res.elements.name);
        setPhone(res.elements.phone);
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      const res = await apiUser.getAllOrders();
      if (res) {
        setOrders(res.elements);
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      const res = await apiOrder.getOrderDetalsByUserId();
      if (res) {
        setOrderDetails(res.elements);
      }
    };
    getData();
  }, []);

  function isValidVietnamPhone(phoneNumber) {
    const vietnamPhoneRegex = /^(03|05|07|08|09)\d{8}$/;
    return vietnamPhoneRegex.test(phoneNumber);
  }
  function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
  }
  function isValidPassword(password) {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*()-+=])[A-Za-z\d@#$%^&*()-+=]{8,}$/;
    return passwordRegex.test(password);
  }

  const handleClickModify = async () => {
    let params = {
      name: name,
      phone: phone
    }
    const res = await apiUser.postUpdateProfile(params);
    if(res){
      toast.success("Đổi thông tin thành công")
    }
    else{
      toast.error("Cập nhật thông tin thất bại")
    }
  };

  const handleClickChangeName = async () => {
    setIsChangeName(!isChangeName);
  };

  const handleClickChangePhone = async () => {
    setIsChangePhone(!isChangePhone);
  };
  const handleClickLogout = async () => {
    const res = await apiUser.logout();
    if (res) {
      localStorage.removeItem("user");
      toast.success("Đăng xuất thành công");
      window.location.href = "/login/email";
    } else {
      toast.error("Đăng xuất thất bại");
    }
  };
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { label: "Thông tin tài khoản", content: "Nội dung của Tab 1" },
    { label: "Thông tin đơn hàng", content: "Nội dung của Tab 2" },
    { label: "Danh sách vé", content: "Nội dung của Tab 3" },
  ];

  return (
    <>
      <HeaderNav />
      <ToastContainer/>
      <div className="profile-page">
        <div className="vertical-tabs-container">
          <div className="tabs">
            <p>Xin chào, {name}</p>
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`tab ${activeTab === index ? "active" : ""}`}
                onClick={() => setActiveTab(index)}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div className="tab-content">
            {activeTab === 0 ? (
              <>
                <>
                  <h2>Thông tin tài khoản</h2>
                  <div className="tab-info">
                    <div className="row-content">
                      <h3>Tên của bạn</h3>
                      {isChangeName ? (
                        <>
                          <button onClick={() => handleClickChangeName()}>Lưu lại</button>
                        </>
                      ) : (
                        <>
                          <button onClick={() => handleClickChangeName()}>
                            Chỉnh sửa
                          </button>
                        </>
                      )}
                    </div>
                    <div className="info-content">
                      <input
                        type="text"
                        placeholder="Họ và tên"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        style={{ paddingRight: 10, marginRight: "30px" }}
                        disabled={!isChangeName}
                      />
                    </div>
                    <p>Việc cập nhật thông tin chính xác của quý khách sẽ giúp chúng tôi có thể phục vụ quý khách được tốt hơn và trọn vẹn.</p>
                    <div className="row-content">
                      <h3>Số điện thoại của bạn</h3>
                      {isChangePhone ? (
                        <>
                          <button
                           onClick={() => handleClickChangePhone()}>
                            Lưu lại
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={() => handleClickChangePhone()}
                          >
                            Chỉnh sửa
                          </button>
                        </>
                      )}
                    </div>
                    
                    <div className="info-content">
                      <input
                        type="text"
                        placeholder="Số điện thoại"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        style={{ paddingRight: 10, marginRight: "30px" }}
                        disabled={!isChangePhone}
                      />
                    </div>
                    <div className="center">
                      <button className="button-style-confirm" onClick={() => handleClickModify()}>
                        Lưu thông tin
                      </button>
                    </div>
                    <div className="center">
                      <p></p>
                    </div>
                    <div className="center">
                      <button className="button-style-confirm" onClick={() => handleClickLogout()}>
                        Đăng xuất
                      </button>
                    </div>
                  </div>
                </>
              </>
            ) : activeTab === 1 ? (
              <>
                <h2>Danh sách đơn hàng</h2>
                <div className="table-container">
                  {orders.length > 0 ? (
                    <>
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>Ngày đặt hàng</th>
                            <th>Giá trị</th>
                            <th>Trạng thái</th>
                            <th>Thao tác</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orders.map((item) => (
                            <tr
                              key={item.id}
                              style={{
                                backgroundColor:
                                  item.status === "0"
                                    ? "#81d4f9"
                                    : item.status === "1"
                                    ? "#93cf96"
                                    : "#f178a1",
                              }}
                            >
                              <td>{item.create_at.split("T")[0]}</td>
                              <td>{numberWithCommas(item.total)}</td>
                              <td>
                                {item.status === "0"
                                  ? "Chưa thanh toán"
                                  : item.status === "1"
                                  ? "Đã thanh toán"
                                  : "Đã hủy"}
                              </td>
                              <td>
                                {item.status === "0" ? (
                                  <a href={`/payment/${item.id}`}>Thanh toán</a>
                                ) : item.status === "1" ? (
                                  <a href={`/payment/${item.id}`}>Hủy đơn</a>
                                ) : (
                                  "Đã hủy"
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <>
                      <div className="center">
                        <h2> Bạn chưa có đơn hàng nào cả</h2>
                      </div>
                    </>
                  )}
                </div>
              </>
            ) : (
              <>
                {orderDetails.length > 0 ? (
                  <>
                    <h2>Danh sách vé</h2>
                    <div className="content-scrollable">
                      {orderDetails.map((item) => (
                        <>
                          <OrderDetail ticket={item}></OrderDetail>
                        </>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="center">
                      <h2>Bạn chưa đặt vé nào cả</h2>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <FooterContent />
    </>
  );
}
export default Profile;
